import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreRegistrationComponent } from './pre-registration/pre-registration.component';
import { AccountRegistrationComponent } from './account-registration/account-registration.component';
import { LoginComponent } from './login/login.component';
import { PreRegistrationGdprComponent } from './pre-registration-gdpr/pre-registration-gdpr.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CountryResolverService } from './services/resolvers.service';
import { PaymentComponent } from './payment/payment.component';
import { AgentLoginComponent } from './agent-login/agent-login.component';
import { AgentSetPasswordComponent } from './agent-set-password/agent-set-password.component';
import { AgentAccountRegistrationComponent } from './account-registration/agent-account-registration/agent-account-registration.component';
import { AgentForgotPasswordComponent } from './agent-forgot-password/agent-forgot-password.component';
import { AgentResetPasswordComponent } from './agent-reset-password/agent-reset-password.component';
import { ServerErrorComponent } from './server-error/server-error.component';

const routes: Routes = [
  { path: 'pre-registration', component: PreRegistrationComponent, resolve: { countries: CountryResolverService}   },
  { path: 'pre-registration-gdpr', component: PreRegistrationGdprComponent   },
  { path: 'account-registration', component: AccountRegistrationComponent },
  { path: 'agent-account-registration', component: AgentAccountRegistrationComponent },  
  { path: 'login', component: LoginComponent },
  { path: 'agent-login', component: AgentLoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'agent-forgot-password', component: AgentForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent},
  { path: 'agent-reset-password', component: AgentResetPasswordComponent },
  { path: 'agent-set-password', component: AgentSetPasswordComponent },
  { path: 'online-payment', component: PaymentComponent },
  { path: 'online-payment/:paymentStatus', component: PaymentComponent },
  { path: 'server-error', component: ServerErrorComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharedRoutingModule { }
